export const viewModeType = {
    list: 'list',
    kanban: 'kanban',
};